export function toHashMapString(obj) {
    if (!obj)
        return;
    var hm = {};
    Object.keys(obj).forEach(function (k) {
        if (typeof obj[k] === "object") {
            hm[k] = JSON.stringify(obj[k]);
        }
        else {
            hm[k] = String(obj[k]);
        }
    });
    return hm;
}
export function toHashMap(obj) {
    if (!obj)
        return;
    var hm = {};
    Object.keys(obj).forEach(function (k) {
        if (typeof obj[k] === "string" ||
            typeof obj[k] === "boolean" ||
            typeof obj[k] === "number") {
            hm[k] = obj[k];
        }
        else {
            hm[k] = JSON.stringify(obj[k]);
        }
    });
    return hm;
}
//# sourceMappingURL=hashmap.js.map